export function isObject(x: unknown): x is Record<string, unknown> {
	return typeof x === 'object' && x !== null && x !== undefined;
}

export function isDate(input: unknown): input is Date {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return isObject(input) && Object.prototype.toString.call(input) === '[object Date]' && !isNaN(input as any);
}

export function isValidNumber(input: unknown): input is number {
	return typeof input === 'number' && !isNaN(input);
}
